import * as React from "react";
import PropTypes from 'prop-types';

const SvgCouponDrawer = props => {
  if (props.id !== "_svgcoupondrawer") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><path d="M20.725 11.913V11H13v24H34V11H26.091v.913c0 1.504-1.201 2.724-2.682 2.724-1.483 0-2.684-1.22-2.684-2.724zM22.778 24.7l4.004-5.624h1.672l-4.662 6.396-3.987 5.607h-1.673l4.646-6.379zm4.105 5.196c-.76 0-1.3-.772-1.3-1.749v-.034c0-.926.472-1.715 1.266-1.715.76 0 1.301.789 1.301 1.749v.034c0 .926-.473 1.715-1.267 1.715zm-7.18-4.818c-1.655 0-2.77-1.39-2.77-3.035v-.035c0-1.68 1.132-3.069 2.804-3.069 1.673 0 2.77 1.389 2.77 3.035v.034c0 1.664-1.114 3.07-2.804 3.07zm0-4.819c.76 0 1.301.79 1.301 1.75v.034c0 .926-.473 1.714-1.267 1.714-.76 0-1.3-.771-1.3-1.749v-.034c0-.926.472-1.715 1.266-1.715zm7.146 10.957c-1.655 0-2.77-1.389-2.77-3.035v-.034c0-1.68 1.132-3.07 2.804-3.07 1.656 0 2.77 1.39 2.77 3.036v.034c0 1.663-1.131 3.07-2.804 3.07z" fill="currentColor" fillRule="evenodd" /></svg>;
};

SvgCouponDrawer.displayName = "_svgcoupondrawer";
SvgCouponDrawer.propTypes = {
  id: PropTypes.string
};
SvgCouponDrawer.defaultProps = {
  id: ''
};
export default SvgCouponDrawer;